export const MINIMUM_AGE = 18;

export const MINIMUM_AGE_ERROR = 'You must be at least 18 years old to take tests.';
